import pako from "pako";
import { isWIX, state } from "../settings";

export let needsUpdate = false;
export let isRedirectionProject = false;

const splitState = "state=";

export function encodeStateToURL(state) {
  const stateCopy = {
    t3: state.type3Dmodel,
    ec: state.endCuts,
    ov: state.overhang,
    tb: state.typePergola,
    rt: state.roofType,
    dr: state.directionRoof ? 1 : 0,
    gb: state.goldBar ? 1 : 0,
    rc: state.roofColorType,
    pos: state.postSize,
    post: state.postType,
    bm: state.beam,
    wo: state.wallOption,
    st: state.steel,
    wk: state.wrapKit,
    tl: state.tails,
    ht: state.heaterType,
    rt: state.railingType,
    sht: state.shuttersType,
    bs: state.beamSize,
    gt: state.gutter,
    rz: state.currentRotationZ,
    isRot: state.isRotated ? 1 : 0,
    dirr: state.dirRalling ? 1 : 0,
    tgs: state.typeSlideGlass ? 1 : 0,
    h: state.height,
    l: state.length,
    w: state.width,
    ivps: state.initValuePostSize,
    bw: state.backWall ? 1 : 0,
    lw: state.leftWall ? 1 : 0,
    rw: state.rightWall ? 1 : 0,
    cr: state.colorRoof,
    crs: state.colorRoofSolid,
    cb: state.colorBody,
    cl: state.colorLed,
    e: [...state.electro.values()],
    dm: state.dayMode ? 1 : 0,
    sp: state.spacing,
    rn: state.rain,
    sli: state.slidingShuttersInput,
    slr: state.slidingShuttersRotate,
    tlsr: state.typeLiteShadeRoof,
    css: state.currentSubSystem,
    fah: state.fanAvatarHeight,
    faw: state.fanAvatarWidth,
    po: state.portalOption ?? 0,
    rsc: state.roofScreenColor,
    ss: [...state.subSystem.values()],
    ssu: [...state.subSystemUrl.values()],
    htu: [...state.heatersUrl.values()],
    ps: state.patternScreen,
    psr: state.patternScreenRoof,
    cs: state.colorScreen,
    zipi: state.zipInput,
    sls: state.slatsSize,
    sld: state.slidingDoorInput,
    ofs: state.offsetForShade,
    bii: state.biFoldDoorInput,
    thi: state.thickness,
    rf: state.rafter,
    sl: state.skyLight,
    rml: state.removeLettice,
    sld: state.slidingDoorInput,
    bisi: state.biFoldDoorShattersInput,
    bisr: state.biFoldDoorShattersRotate,
    mpsz: state.midPointForScreenZ,
    mpsx: state.midPointForScreenX,
    trc: state.transparency ?? 0,
    cz: state.colorZip,
    cas: state.currentActiveSpans,
    img: state.imgForPdf ?? 0,
  };

  const jsonString = JSON.stringify(stateCopy);
  const compressed = pako.deflate(jsonString, { to: "string" });

  const base64String = arrayBufferToBase64(compressed);

  return base64String;
}

function arrayBufferToBase64(buffer) {
  const binary = Array.from(buffer)
    .map((byte) => String.fromCharCode(byte))
    .join("");

  return window.btoa(binary);
}

export function decodeURLToState(url) {
  try {
    const decompressedBase64 = atob(url);
    const decompressedArray = new Uint8Array(
      decompressedBase64.split("").map((c) => c.charCodeAt(0))
    );

    const decompressed = pako.inflate(decompressedArray, { to: "string" });

    const decodedState = JSON.parse(decompressed);

    return {
      type3Dmodel: decodedState.t3,
      endCuts: decodedState.ec,
      overhang: decodedState.ov,
      typePergola: decodedState.tb,
      directionRoof: decodedState.dr === 1,
      goldBar: decodedState.gb === 1,
      dirRalling: decodedState.dirr === 1,
      typeSlideGlass: decodedState.tgs === 1,
      roofColorType: decodedState.rc,
      roofType: decodedState.rt,
      postSize: decodedState.pos,
      postType: decodedState.post,
      shuttersType: decodedState.sht,
      beam: decodedState.bm,
      steel: decodedState.st,
      wrapKit: decodedState.wk,
      beamSize: decodedState.bs,
      tails: decodedState.tl,
      gutter: decodedState.gt,
      rain: decodedState.rn,
      heaterType: decodedState.ht,
      railingType: decodedState.rt,
      slidingShuttersInput: decodedState.sli,
      slidingShuttersRotate: decodedState.slr,
      slidingDoorInput: decodedState.sld,
      skyLight: decodedState.sl,
      currentRotationZ: decodedState.rz,
      isRotated: decodedState.isRot === 1,
      height: decodedState.h,
      length: decodedState.l,
      width: decodedState.w,
      initValuePostSize: decodedState.ivps,
      backWall: decodedState.bw === 1,
      leftWall: decodedState.lw === 1,
      rightWall: decodedState.rw === 1,
      wallOption: decodedState.wo,
      colorRoof: decodedState.cr,
      colorRoofSolid: decodedState.crs,
      colorBody: decodedState.cb,
      colorLed: decodedState.cl,
      electro: new Set(decodedState.e),
      dayMode: decodedState.dm === 1,
      spacing: decodedState.sp,
      typeLiteShadeRoof: decodedState.tlsr,
      currentSubSystem: decodedState.css,
      fanAvatarHeight: decodedState.fah,
      fanAvatarWidth: decodedState.faw,
      portalOption: decodedState.po === 0 ? null : decodedState.po,
      roofScreenColor: decodedState.rsc,
      subSystem: new Set(decodedState.ss),
      subSystemUrl: new Set(decodedState.ssu),
      heatersUrl: new Set(decodedState.htu),
      patternScreen: decodedState.ps,
      patternScreenRoof: decodedState.psr,
      colorScreen: decodedState.cs,
      slatsSize: decodedState.sls,
      zipInput: decodedState.zipi,
      slidingDoorInput: decodedState.sld,
      biFoldDoorInput: decodedState.bii,
      biFoldDoorShattersInput: decodedState.bisi,
      biFoldDoorShattersRotate: decodedState.bisr,
      thickness: decodedState.thi,
      rafter: decodedState.rf,
      removeLettice: decodedState.rml,
      offsetForShade: decodedState.ofs,
      midPointForScreenZ: decodedState.mpsz,
      midPointForScreenX: decodedState.mpsx,
      transparency: decodedState.trc === 0 ? null : decodedState.trc,
      colorZip: decodedState.cz,
      currentActiveSpans: decodedState.cas,
      imgForPdf: decodedState.img === 0 ? null : decodedState.img,
    };
  } catch (error) {
    console.error("Помилка при декодуванні стану:", error);
    return {};
  }
}

export function changeURL() {
  const url = encodeStateToURL(state);
  let newUrl = `${window.location.origin}${window.location.pathname}?${splitState}${url}`;
  history.pushState({}, "", newUrl);

  if (isWIX) {
    const urlParams = window.location.search;
    window.parent.postMessage("URL_Params|" + urlParams, "*");
  }
}

export async function initStateFromUrl(wixParams) {
  // console.log("🚀 ~ initStateFromUrl ~ wixParams:", wixParams);
  const splitState = "state=";
  let stateParam;

  let paramsString =
    wixParams && typeof wixParams === "string" && wixParams.length > 0
      ? decodeURIComponent(wixParams)
      : wixParams || window.location.search;

  const cleanParams = paramsString.startsWith("?")
    ? paramsString.slice(1)
    : paramsString;

  if (!cleanParams.includes("=")) {
    stateParam = cleanParams;
  } else {
    const formattedParams = cleanParams.startsWith(splitState)
      ? cleanParams
      : `${splitState}${cleanParams}`;
    const urlParams = new URLSearchParams(formattedParams);
    stateParam = urlParams.get("state");
    const onlyAR = urlParams.get("onlyAR");

    if (onlyAR !== null) {
      isRedirectionProject = onlyAR === "true";
    }
  }

  if (stateParam) {
    try {
      stateParam = stateParam.replace(/ /g, "+");
      const decodedState = decodeURLToState(stateParam);

      for (const key in decodedState) {
        state[key] = decodedState[key];
      }

      console.log("Стан завантажено з URL:", state);
    } catch (error) {
      console.error("Помилка при декодуванні стану з URL:", error);
    }
  } else {
    console.log("Використовуємо дефолтний стан:", state);
  }

  needsUpdate = true;
}
